export const FORMS_CONTEXT_KEY = 'forms:auto';

/** Snapshot of the active form-definition list used by navigation lists. */
export const formDefinitionsListKey = 'forms:definitions';

/** Snapshot of one flattened form definition, keyed by its id. */
export const formDefinitionKey = (formDefinitionId: number): string =>
  `form-definition:${formDefinitionId}`;

/** Snapshot of the form state machine (static per instance), used by the fill
 * Save bar so it works offline. */
export const formStateMachineKey = 'forms:state-machine';

/** Snapshot of the personnel reference section (scope id + compact rows). */
export const formsPersonnelKey = 'forms:personnel';

/** Snapshot of the asset reference section (scope id + compact rows). */
export const formsAssetsKey = 'forms:assets';
